import {isAbsent, isPresent} from '@/utils/null';

/**
 * Returns all the mentioned properties as an array.
 * Absent properties will not be included.
 * Both ['foo', 'bar'] and 'foo.bar' formats are supported for each property.
 *
 * @param {*} obj
 * @param {string|string[]} properties Strings or string arrays representing property paths
 * @return {Array}
 */
export function collectValues(obj, ...properties) {
  const res = [];
  for (let i = 0; i < properties.length; i++) {
    let prop = properties[i];
    if (!Array.isArray(prop)) prop = prop.split('.');

    let o = obj;
    for (let j = 0; j < prop.length; j++) {
      if (isAbsent(o)) break;
      o = o[prop[j]];
    }
    if (isPresent(o)) {
      res.push(o);
    }
  }
  return res;
}
